import * as store from "../state/store.js";
import type { HistoryEntry } from "../state/types.js";
import { toast } from "./ui.js";

// Snapshot the mutable slices of state into an undo/redo entry. Called by
// user-facing ops right after they mutate the store.
export function checkpoint(action: string): void {
  if (!store.isLoaded()) return;

  const entities = store.entities().map((e) => ({
    ...e,
    points: e.points.map(([x, y]) => [x, y] as [number, number]),
    data: { ...e.data },
  }));

  const layers: HistoryEntry["data"]["layers"] = {};
  for (const [name, layer] of Object.entries(store.layers())) {
    layers[name] = { ...layer, entityIds: [...layer.entityIds] };
  }

  const entry: HistoryEntry = {
    action,
    timestamp: Date.now(),
    data: {
      entities,
      layers,
      layerOrder: [...store.layerOrder()],
      selectedEntityIds: Array.from(store.selectedEntityIds()),
      selectedLayerNames: Array.from(store.selectedLayerNames()),
      selectedLayer: store.selectedLayer(),
      bounds: store.bounds() ? { ...store.bounds()! } : null,
    },
  };

  store.pushHistory(entry);
}

export function undo(): void {
  const entry = store.stepHistory(-1);
  if (!entry) return;
  restore(entry);
  toast(`Undo: ${entry.action}`);
}

export function redo(): void {
  const entry = store.stepHistory(1);
  if (!entry) return;
  restore(entry);
  toast(`Redo: ${entry.action}`);
}

function restore(entry: HistoryEntry): void {
  const d = entry.data;
  store.batch(() => {
    store.write.entities(d.entities);
    store.write.layers(d.layers);
    store.write.layerOrder(d.layerOrder);
    store.write.selectedEntityIds(new Set(d.selectedEntityIds));
    store.write.selectedLayerNames(new Set(d.selectedLayerNames));
    store.write.selectedLayer(d.selectedLayer);
    store.write.bounds(d.bounds);
  });
}
